import { openWorkspaceDb } from '@/offline/db'
import { atomicLocalWrite, buildOperation } from '@/offline/queue'
import { pushOutbox, type PushSummary } from '@/offline/sync'
import { supabaseTransport } from '@/offline/transport'
import type { BuiltCategoryCreate, BuiltCategoryUpdate } from './categoryPayload'

export async function saveCategoryCreate(workspaceId: string, built: BuiltCategoryCreate): Promise<PushSummary> {
  const db = openWorkspaceDb(workspaceId)
  const op = buildOperation({
    workspace_id: workspaceId,
    entity_id: built.category.id,
    entity_type: 'category',
    expected_revision: null,
    action: 'category.create',
    payload: built.payload,
  })
  await atomicLocalWrite(db, [db.categories], async () => {
    await db.categories.add(built.category)
  }, op)
  return pushOutbox(db, supabaseTransport())
}

export async function saveCategoryUpdate(workspaceId: string, built: BuiltCategoryUpdate): Promise<PushSummary> {
  const db = openWorkspaceDb(workspaceId)
  const op = buildOperation({
    workspace_id: workspaceId,
    entity_id: built.category.id,
    entity_type: 'category',
    expected_revision: built.expectedRevision,
    action: 'category.update',
    payload: built.payload,
  })
  await atomicLocalWrite(db, [db.categories], async () => {
    await db.categories.put(built.category)
  }, op)
  return pushOutbox(db, supabaseTransport())
}
